export default __webpack_public_path__ + "static/media/icon-incorrect-card.9130bf98.svg";